'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosFilm = function IoIosFilm(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm4.5 6.9h31.3v26.2h-31.3v-26.2z m5.6 25v-3.8h-4.3v3.8h4.3z m0-5v-3.8h-4.3v3.8h4.3z m0-5v-3.8h-4.3v3.8h4.3z m0-5v-3.8h-4.3v3.8h4.3z m0-5v-3.8h-4.3v3.8h4.3z m18.8 8.7v-1.2h-17.5v1.2h17.5z m5.6 11.3v-3.8h-4.4v3.8h4.4z m0-5v-3.8h-4.4v3.8h4.4z m0-5v-3.8h-4.4v3.8h4.4z m0-5v-3.8h-4.4v3.8h4.4z m0-5v-3.8h-4.4v3.8h4.4z' })
        )
    );
};

exports.default = IoIosFilm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-film.js
// module id = 2184
// module chunks = 0